import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import ReleaseLayer from "../../components/ReleaseLayer";

const ReleasePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* ReleaseLayer */}
                <ReleaseLayer />
            </MasterLayout>
        </>
    );
};

export default ReleasePage;